import { render } from "./Title.vue?vue&type=template&id=d2e3f362&scoped=true&ts=true&lang=pug"
import script from "./Title.vue?vue&type=script&lang=ts"
export * from "./Title.vue?vue&type=script&lang=ts"

import "./Title.vue?vue&type=style&index=0&id=d2e3f362&scoped=true&lang=css"

import exportComponent from "/Users/lauriel/gitRepos_work/hero/hero_web_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2e3f362"]])

export default __exports__